import styled from "styled-components";
import RowOption from '../rowOption.jsx';
import TextAreaDescripcion from '../textAreaDescripcion.jsx'
import Categorias from './categorias.jsx'
import SelectOption from '../selectOption.jsx';

const Container=styled.div`
	width:100%;
	display:flex;
	align-items:center
`
const Info=styled.div`
	width:95%;
	border-radius:10px;
	display:flex;
	flex-direction:column;
	align-items:center;
	margin-bottom:15px;
	padding:15px
`



export default function DetailGame(props){
	
	let{ value,action,estado}=props;

	let dataPlayers=[{label:"seleccionar...", value:0},{label:"1", value:"1"},{label:"2+",value:"2+"}];
	


	return(
		<Container>			
      <h1>Detalle</h1>
 				<Info> 							
 								<RowOption label="audio" value={value.audio} action={action} estado={estado}/>
 								<RowOption label="subtitulos" value={value.subtitulos} action={action} estado={estado}/>
 								<RowOption label="peso" value={value.peso} action={action} estado={estado} />
 							{estado!==0?
 								<SelectOption value={value.multiplayerOffLine} id={value.id} action={action} consolaIndice={value.multiplayerOffLine}  estado={estado} label="multiplayerOffLine"  data={dataPlayers}/>:
 								<RowOption label="multiplayerOffLine" value={value.multiplayerOffLine} action={action} estado={estado}  />}
 						
 								<RowOption label="multiplayerOnLine" value={value.multiplayerOnLine} action={action} estado={estado}  />
 								<Categorias  value={value.Categoria} action={action} />
 				</Info>
 							<TextAreaDescripcion label="descripcion" value={value.descripcion}  estado={estado} action={action}  />
 						
 		</Container>

		)
}